import styled, { css } from 'styled-components';
import { mqMediumMin, mqLargeMin } from 'styled/tools/media-queries';
import type { BrandIconColor, BrandIconSize } from './brand-icons';

const sizeStyles: Record<BrandIconSize, ReturnType<typeof css>> = {
  sm: css`
    width: 24px;
    height: 24px;
  `,
  md: css`
    width: 32px;
    height: 32px;
  `,
  lg: css`
    width: 38px;
    height: 38px;
  `,
};

const colorStyles: Record<BrandIconColor, ReturnType<typeof css>> = {
  dark: css`
    color: var(--actions-primary);
  `,
  light: css`
    color: var(--actions-inverse);
  `,
};

interface StyledBrandIconProps {
  $sizeBase: BrandIconSize;
  $sizeTablet?: BrandIconSize;
  $sizeDesktop?: BrandIconSize;
  $color?: BrandIconColor;
}

export const SvgBrandIcon = styled.svg<StyledBrandIconProps>`
  color: inherit;

  * {
    color: inherit;
  }

  ${({ $color }) => $color && colorStyles[$color]}

  ${({ $sizeBase }) => sizeStyles[$sizeBase]}

  ${({ $sizeTablet }) =>
    $sizeTablet &&
    css`
      @media ${mqMediumMin} {
        ${sizeStyles[$sizeTablet]}
      }
    `}

  ${({ $sizeDesktop }) =>
    $sizeDesktop &&
    css`
      @media ${mqLargeMin} {
        ${sizeStyles[$sizeDesktop]}
      }
    `}
`;
